import PATH from '@/routes/path';
import { MenuItem } from '@/types/menu';
import { ROLE } from './user';
import {
  IconBank,
  IconChat,
  IconGroup,
  IconManual,
  IconMember,
  IconSetting,
} from '@/components/icons';

export const MENU_ITEMS: MenuItem[] = [
  {
    title: 'menu.member_group',
    link: PATH.coach_management,
    auth: true,
    icon: IconMember,
    // MENTOR is on the parent so its child below can show; every other child
    // keeps its own roles and stays hidden.
    roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN, ROLE.TEACHER, ROLE.MENTOR],
    key: 'member_group',
    children: [
      {
        title: 'menu.mentor_coach_management',
        link: PATH.mentor_coach_management,
        auth: true,
        roles: [ROLE.MENTOR],
        key: 'member_group',
      },
      {
        title: 'menu.coach_management',
        link: PATH.coach_management,
        auth: true,
        roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN],
        key: 'member_group',
      },
      {
        title: 'menu.mentor_management',
        link: PATH.mentor_management,
        auth: true,
        roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN],
        key: 'member_group',
      },
      {
        title: 'menu.user_management',
        link: PATH.user_management,
        auth: true,
        roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN],
        key: 'member_group',
      },
      {
        title: 'menu.student_management',
        link: PATH.student_management,
        auth: true,
        roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN, ROLE.TEACHER],
        key: 'member_group',
      },
    ],
  },
  {
    title: 'menu.function_group',
    link: PATH.lesson,
    auth: true,
    icon: IconGroup,
    roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN, ROLE.TEACHER, ROLE.MENTOR],
    key: 'function_group',
    children: [
      {
        title: 'menu.mentor_lesson_management',
        link: PATH.mentor_lesson_management,
        auth: true,
        roles: [ROLE.MENTOR],
        key: 'function_group',
      },
      {
        title: 'menu.lesson',
        link: PATH.lesson,
        auth: true,
        roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN, ROLE.TEACHER],
        key: 'function_group',
      },
      {
        title: 'menu.graduation',
        link: PATH.graduation,
        auth: true,
        roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN],
        key: 'function_group',
      },
      {
        title: 'menu.plan',
        link: PATH.plan,
        auth: true,
        roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN],
        key: 'function_group',
      },
      {
        title: 'menu.gift',
        link: PATH.gift,
        auth: true,
        roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN],
        key: 'function_group',
      },
    ],
  },
  {
    title: 'menu.payment_group',
    link: '',
    auth: true,
    icon: IconBank,
    roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN],
    key: 'payment_group',
    children: [
      {
        title: 'menu.payment',
        link: PATH.payment,
        auth: true,
        roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN],
        key: 'payment_group',
      },
    ],
  },
  {
    title: 'menu.chat',
    link: `${PATH.chat}/${PATH.chat_conversation}`,
    parent_link: PATH.chat,
    auth: true,
    icon: IconChat,
    roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN, ROLE.TEACHER, ROLE.MENTOR],
  },
  {
    title: 'menu.manual',
    link: PATH.manual,
    auth: true,
    icon: IconManual,
    roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN, ROLE.TEACHER],
    is_link_external: true,
  },
  {
    title: 'menu.setting',
    link: PATH.version_management,
    auth: true,
    icon: IconSetting,
    roles: [ROLE.SUPPER_ADMIN],
    key: 'setting',
    children: [
      {
        title: 'menu.version_management',
        link: PATH.version_management,
        auth: true,
        roles: [ROLE.SUPPER_ADMIN],
        key: 'setting',
      },
    ],
  },
];

export const MENU_COACH_TRIAL_ITEMS: MenuItem[] = [
  {
    title: 'menu.chat',
    link: `${PATH.chat}/${PATH.chat_conversation}`,
    parent_link: PATH.chat,
    auth: true,
    icon: IconChat,
    roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN, ROLE.TEACHER],
  },
  {
    title: 'menu.manual',
    link: PATH.manual,
    auth: true,
    icon: IconManual,
    roles: [ROLE.SUPPER_ADMIN, ROLE.ADMIN, ROLE.TEACHER],
    is_link_external: true,
  },
];
